import React from 'react';

interface ExpertSkillsNavIconProps {
  /** 人形描边颜色（激活态传 #FF6D49，未激活传 #FFF） */
  color?: string;
  size?: number;
}

/**
 * 侧边导航「专家&Skills」图标：双人（专家 / 专家团）+ 橙色渐变技能星点。
 *
 * 由 MainLayout / AgreementLayout 两个 sidebar 共用，确保样式同步。
 * 人形描边颜色随激活态变化；星点恒为橙色渐变（呼应项目其他导航图标的高亮风格）。
 */
const ExpertSkillsNavIcon: React.FC<ExpertSkillsNavIconProps> = ({ color = '#FFF', size = 19 }) => {
  // 渐变 id 唯一，避免多实例同时挂载时冲突
  const gid = React.useId();
  return (
    <svg width={size} height={size} viewBox="0 0 19 19" fill="none">
      <circle cx="7" cy="6.4" r="2.5" stroke={color} strokeWidth="1.2" />
      <path
        d="M2.6 15c0-2.7 2.2-4.1 4.4-4.1s4.4 1.4 4.4 4.1"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <path d="M12.4 5.2a2.1 2.1 0 0 1 .1 4.1" stroke={color} strokeWidth="1.2" strokeLinecap="round" />
      <path d="M13.2 11c2 .2 3.3 1.6 3.3 3.9" stroke={color} strokeWidth="1.2" strokeLinecap="round" />
      <path d="M15 2.3l.5 1.3 1.3.5-1.3.5-.5 1.3-.5-1.3-1.3-.5 1.3-.5z" fill={`url(#${gid})`} />
      <defs>
        <linearGradient id={gid} x1="15" y1="2.3" x2="15" y2="6">
          <stop stopColor="#F8A749" />
          <stop offset="1" stopColor="#F8A749" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default ExpertSkillsNavIcon;
